import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import MarkdownRenderer from "../common/MarkdownRenderer";
import { getProject, getProjectSections } from "../../lib/loadContent";

const ProjectDetail = () => {
  const { slug } = useParams();
  const project = getProject(slug);
  const [section, setSection] = useState("overview");

  if (!project) {
    return (
      <div className="page">
        <h1 className="page-title">404</h1>
        <p>
          Project <code>{slug}</code> not found.
        </p>
        <Link to="/projects">← back to projects</Link>
      </div>
    );
  }

  const sections = getProjectSections(project);

  const handleSectionClick = (sectionId) => {
    setSection(sectionId);
    // Scroll the .editor container, not the whole page
    const editor = document.querySelector(".editor");
    const heading = document.getElementById(sectionId);
    if (editor && heading) {
      const editorRect = editor.getBoundingClientRect();
      const headingRect = heading.getBoundingClientRect();
      const offset = headingRect.top - editorRect.top - 16;
      editor.scrollBy({ top: offset, behavior: "smooth" });
    }
  };

  return (
    <div className="page project-detail">
      <div className="project-detail-head">
        {project.hero && (
          <img
            className="project-detail-hero"
            src={project.hero}
            alt={`${project.title} hero`}
          />
        )}
        <div>
          <h1 className="page-title">{project.title}</h1>
          <p className="page-path">~/portfolio/projects/{project.slug}.md</p>
        </div>
      </div>

      <div className="project-layout">
        <nav className="project-sidenav" aria-label="Project sections">
          {sections.map((s) => (
            <button
              key={s.id}
              type="button"
              className={
                "project-sidenav-item" + (section === s.id ? " active" : "")
              }
              onClick={() => handleSectionClick(s.id)}
            >
              {s.label}
            </button>
          ))}
        </nav>
        <div className="project-content">
          <MarkdownRenderer>{project.content}</MarkdownRenderer>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;